import { getConfig } from '../../config';
import getFormatMessage from '../../locales/get-format-message';
import { GameEnvRegion, IGameEnvModel } from '../../model/api-modules/env';

export const getEnvNameByValue = (region: GameEnvRegion) => {
  switch (region) {
    case GameEnvRegion['European(Frankfurt)']:
      return getFormatMessage('european_label_type');
    case GameEnvRegion['Asian(Singapore)']:
      return getFormatMessage('asian_label_type');
    case GameEnvRegion['North America(Virginia)']:
      return getFormatMessage('north_label_type');
    case GameEnvRegion['East China(Shanghai)']:
      return getFormatMessage('east_label_type');
    case GameEnvRegion.Woa:
      return getFormatMessage('woa_label_type');
    case GameEnvRegion.DevCloud:
      return getFormatMessage('dev_cloud_label_type');
    default:
      return '';
  }
};

export const getGameEnvTypeOptions = () => {
  const list: { label: string; value: GameEnvRegion }[] = [];
  getConfig().gameConfig.region.forEach(([label, value]) => {
    list.push({
      label,
      value: value as GameEnvRegion,
    });
  });
  return list;
};

export const filterCurAreaEnvList = (envs: ReadonlyArray<IGameEnvModel>) => {
  return envs.filter((v) =>
    getConfig()
      .gameConfig.region.map((v) => v[1])
      .includes(v.Region)
  );
};

export const getArea = () => {
  // 测试环境 Cookie 域名
  // if (location.hostname.indexOf('.woa.com') !== -1) {
  //   return 2;
  // }
  // // 海外官网预发布Cookie 域名
  // if (location.hostname.indexOf('.crosgame.com') !== -1) {
  //   return 4;
  // }
  return 4;
};
